import { render, staticRenderFns } from "./ChallengeDetail.vue?vue&type=template&id=61bcd5a4&"
import script from "./ChallengeDetail.vue?vue&type=script&lang=js&"
export * from "./ChallengeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeDetail.vue?vue&type=style&index=0&id=61bcd5a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports